/* InkMerge Studio — curated customer text fonts, grouped by style */
(function () {
  // family: CSS font-family value; needsImport: include in google fonts import
  const FONTS = [
    // Clean
    { name: "Montserrat",     family: "'Montserrat', sans-serif",      group: "Clean",   google: "Montserrat:wght@400;600;700" },
    { name: "Poppins",        family: "'Poppins', sans-serif",         group: "Clean",   google: "Poppins:wght@400;600;700" },
    { name: "Inter",          family: "'Inter', sans-serif",           group: "Clean",   google: "Inter:wght@400;600;700" },
    { name: "Helvetica",      family: "Helvetica, Arial, sans-serif",  group: "Clean" },
    { name: "Arial",          family: "Arial, sans-serif",             group: "Clean" },
    // Bold
    { name: "Anton",          family: "'Anton', sans-serif",           group: "Bold",    google: "Anton" },
    { name: "Black Ops One",  family: "'Black Ops One', system-ui",    group: "Bold",    google: "Black+Ops+One" },
    { name: "Impact",         family: "Impact, Haettenschweiler, sans-serif", group: "Bold" },
    // Sport
    { name: "Bebas Neue",     family: "'Bebas Neue', sans-serif",      group: "Sport",   google: "Bebas+Neue" },
    { name: "Oswald",         family: "'Oswald', sans-serif",          group: "Sport",   google: "Oswald:wght@400;600;700" },
    { name: "Graduate",       family: "'Graduate', serif",             group: "Sport",   google: "Graduate" },
    // Vintage
    { name: "Bangers",        family: "'Bangers', system-ui",          group: "Vintage", google: "Bangers" },
    { name: "Abril Fatface",  family: "'Abril Fatface', serif",        group: "Vintage", google: "Abril+Fatface" },
    // Script
    { name: "Pacifico",       family: "'Pacifico', cursive",           group: "Script",  google: "Pacifico" },
    { name: "Lobster",        family: "'Lobster', cursive",            group: "Script",  google: "Lobster" },
    { name: "Dancing Script", family: "'Dancing Script', cursive",     group: "Script",  google: "Dancing+Script:wght@400;700" },
    // Serif
    { name: "Playfair Display", family: "'Playfair Display', serif",   group: "Serif",   google: "Playfair+Display:wght@400;700" },
    { name: "Georgia",        family: "Georgia, 'Times New Roman', serif", group: "Serif" }
  ];

  const GROUP_ORDER = ["Clean", "Bold", "Sport", "Vintage", "Script", "Serif"];

  function familyOf(name) {
    const f = FONTS.find(x => x.name === name);
    return f ? f.family : "Arial, sans-serif";
  }

  window.IM_FONTS = { FONTS, GROUP_ORDER, familyOf };
})();
